import { render } from "./ShowMemberTier.vue?vue&type=template&id=62997cb8&scoped=true"
import script from "./ShowMemberTier.vue?vue&type=script&lang=js"
export * from "./ShowMemberTier.vue?vue&type=script&lang=js"

import "./ShowMemberTier.vue?vue&type=style&index=0&id=62997cb8&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62997cb8"]])

export default __exports__